<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import Card from '@/components/ui/card/Card.vue'
import PerformanceFinanciereRepository from '@/repository/PerformanceFinanciereRepository'
import { formatNumber } from '@/lib/format'
import CardDonutContent from '../ui/card/CardDonutContent.vue'

const data = ref<
  Array<{
    famille_produit: string
    frais_pedagogique: number
    marge_brute: number
  }>
>([])
const loading = ref<boolean>(true)
const currentIndex = ref(0)
const itemsPerPage = 4

const processedData = computed(() => {
  if (!data.value?.length) return []

  return data.value.map((produit) => ({
    agence_title: produit.famille_produit,
    data: [
      {
        name: 'Frais pédagogiques',
        value: produit.frais_pedagogique,
        color: '#FF9898',
      },
      {
        name: 'Marge brute',
        value: produit.marge_brute,
        color: '#98D89E',
      },
    ].filter((item) => item.value > 0),
  }))
})

const canGoLeft = computed(() => currentIndex.value > 0)
const canGoRight = computed(() => {
  const total = processedData.value.length
  return (currentIndex.value + 1) * itemsPerPage < total
})

const navigate = (direction: 'left' | 'right') => {
  if (direction === 'left' && canGoLeft.value) {
    currentIndex.value--
  } else if (direction === 'right' && canGoRight.value) {
    currentIndex.value++
  }
}

onMounted(async () => {
  try {
    loading.value = true
    data.value = await PerformanceFinanciereRepository.getPerformancesParProduit()
  } catch (error) {
    console.error('Erreur lors du chargement des données:', error)
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <Card
    title="Répartition performance financière par famille produit"
    :download-chart="{
      selector: '.grid-cols-4',
      filename: 'performance-financiere-produit.png',
    }"
  >
    <CardDonutContent
      :loading="loading"
      :data="processedData"
      :current-index="currentIndex"
      :items-per-page="itemsPerPage"
      :can-go-left="canGoLeft"
      :can-go-right="canGoRight"
      :value-formatter="formatNumber"
      :show-currency="true"
      @navigate="navigate"
    />
  </Card>
</template>
